export interface InterestMemoryRule {
    id: string;
    text: string;
    createdAt: string;
    updatedAt: string;
    sourceReportId: string;
    itemIds: string[];
    feedback: string;
}

export interface InterestMemory {
    rules: InterestMemoryRule[];
}

export interface InterestFeedbackOption {
    id: string;
    name: string;
    itemIds: string[];
}

export interface InterestMemorySuggestion {
    text: string;
    impact: string;
}

export interface InterestMemorySuggestRequest {
    interestId: string;
    itemIds: string[];
    feedback: string;
}

export interface InterestMemoryAddRequest extends InterestMemorySuggestRequest {
    text: string;
}

export const INTEREST_MEMORY_EXPLANATION =
    "Memory extends the interest definition and applies the next time items are evaluated. Saving does not start an evaluation or change existing results.";
